/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React base styles
import colors from "assets/theme/base/colors";
import colorsDark from "assets/theme/base/ColorsDark";
import borders from "assets/theme/base/borders";

// Soft UI Dashboard PRO React helper functions
import rgba from "assets/theme/functions/rgba";
import pxToRem from "assets/theme/functions/pxToRem";

const { white } = colors;
const { borderRadius } = borders;
const isDarkMode = (theme) => theme.palette?.mode === "dark";

const sidenav = {
  styleOverrides: {
    root: {
      width: pxToRem(250),
      whiteSpace: "nowrap",
      border: "none",
    },

    paper: ({ theme }) => {
      const darkMode = isDarkMode(theme);
      
      return {
        width: pxToRem(250),
        backgroundColor: darkMode 
          ? rgba(theme.palette.background?.paper || "#1e1e2f", 0.95)
          : rgba(white.main, 0.8),
        backdropFilter: darkMode 
          ? `saturate(200%) blur(${pxToRem(30)})`
          : `saturate(200%) blur(${pxToRem(30)})`,
        height: `calc(100vh - ${pxToRem(32)})`,
        margin: pxToRem(16),
        borderRadius: borderRadius.xl,
        border: darkMode ? `1px solid ${rgba(white.main, 0.1)}` : "none",
        boxShadow: darkMode 
          ? `0 8px 32px ${rgba(0, 0, 0, 0.4)}`
          : "none",
      };
    },

    paperAnchorDockedLeft: {
      borderRight: "none",
    },
  },
};

export default sidenav;